import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import './i18n';
import params from 'configs/params';
import * as Sentry from '@sentry/react';
import { registerLicense } from '@syncfusion/ej2-base';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';

registerLicense(params.syncfusionLicenseKey);

Sentry.init({
  dsn: process.env.NODE_ENV !== 'development' ? params.sentryUrl : null,
  autoSessionTracking: true,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  environment: process.env.NODE_ENV,
  release: 'quickshop-' + process.env.NODE_ENV + '-1.0.0',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(App());
